module.exports = __webpack_public_path__ + "static/media/010.344e2789.jpg";